export default __webpack_public_path__ + "static/media/burger-icon.50c9e034.svg";